var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-skeleton-loader',{attrs:{"boilerplate":!_vm.loading,"elevation":2,"type":"list-item-avatar, divider, list-item-three-line"}})
}
var staticRenderFns = []

export { render, staticRenderFns }